import { GameInitData } from '../../types';
import { getBalance, getCustomParams, getTopSlotWinTypes } from './helper';

export const localInitCashReelsData: GameInitData = {
    balance: getBalance(),
    config: {
        rtp: '95',
        bet_limits: [
            10000000, 20000000, 50000000, 100000000, 200000000, 400000000, 600000000, 800000000, 1000000000, 1200000000,
            1400000000, 1600000000, 1800000000, 2000000000
        ],
        default_bet: 100000000,
        popular_bet: 200000000,
        purchased_features: [],
        casino_id: 'clawbastards',
        hide_home_button: false
    },
    state: {
        round: 'string', // предыдуший раунд
        resp: {
            win: true, // выигрыш или нет
            top_slot: {
                // параметры топ слота
                types: getTopSlotWinTypes(),
                type: 'BALL_SPIN',
                multipliers: ['1', '2', '3', '4', '5', '7', '10', '15', '20', '25', '50'],
                multiplier: '7'
            },
            color: 'YELLOW', // цвет вытянутого шара, null - если не вытянула
            bonus_game: 'CASH_REELS',
            cash_reels_params: {
                reels: [
                    ['4', '6', '8', '10', '12', '15', '20', '25', 'DOUBLE', '50', '75', '100', '250'],
                    ['4', '6', '8', '10', '12', '15', '20', '25', 'DOUBLE', '50', '75', '100', '250'],
                    ['4', '6', '8', '10', '12', '15', '20', '25', 'DOUBLE', '50', '75', '100', '250']
                ]
            },
            win_amount: 12345,
            win_type: 'DEFAULT',
            ball_type: ''
        },
        final: true // если false - возвращаемся к бонуске из state.resp
    },
    currency_attributes: {
        code: 'USDT',
        symbol: 'USDT',
        exponent: 8,
        subunits: 2,
        crypto: true
    },
    custom_params: getCustomParams()
};
